import React from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import { Button, Flex, Heading } from 'rebass';
import Field from 'components/Field';
import ErrorMessage from 'components/ErrorMessage';
import { confirmPasswordHandler } from 'utils/validateHandlers';
import Form from 'components/Form';
import { startResetPasswordSubmit, resolveResetPasswordSubmit } from '../actions';
import RESETPASSWORD from '../content';

const ResetPasswordForm: React.FC<any> = ({ location }): JSX.Element => {
  const parsed = queryString.parse(location.search);
  return (
    <Form
      startSubmitAction={startResetPasswordSubmit().type}
      resolveSubmitAction={resolveResetPasswordSubmit().type}
      setPayload={(action: object, payload: any) => ({
        ...action,
        payload: {
          ...payload,
          token: parsed.token,
        },
      })}
    >
      {(formProps: any) => {
        const { form, submitting, values, submitErrors, submitSucceeded } = formProps;

        const confirmPasswordValidate = confirmPasswordHandler(values.password);
        return (
          <>
            {submitSucceeded ? (
              <Heading fontSize={['36px']} textAlign="center" mt={7}>
                {RESETPASSWORD.heading.submitSucceededText}
              </Heading>
            ) : (
              <Flex flexDirection="column" alignItems="center" py={7} px={4}>
                {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
                <Heading fontSize={['36px']} textAlign="center" mb={5}>
                  {RESETPASSWORD.heading.title}
                </Heading>
                <Field
                  name="password"
                  label="New Password"
                  inputType="password"
                  pattern="((?=.*\d)(?=.*[A-Z]).{7,15})[^!@#$%':;{}\[\]`|/\\?~§±^*()_]"
                  patternMismatch="The password should be min 8 characters long, and must contain at least 1 capital letter, and Number (0 to 9). No special characters are allowed"
                  required
                />
                <Field
                  name="confirmPassword"
                  label="Confirm New Password"
                  inputType="password"
                  required
                  validate={confirmPasswordValidate}
                />
                <Button
                  variant={submitting ? 'disabled' : 'primary'}
                  mt={2}
                  mb={3}
                  onClick={form.submit}
                  disabled={submitting}
                >
                  {RESETPASSWORD.button}
                </Button>
              </Flex>
            )}
          </>
        );
      }}
    </Form>
  );
};

export default withRouter(ResetPasswordForm);
